import { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import { MainImage } from "../workDetailPage/WorkMainImage";
import Navigator from '../components/Navigation';
import { WorkFullImage } from "../workDetailPage/WorkFullImage";
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { ArticleMainImage } from "../articleDetailPage/ArticleMainImage";
import image1 from '../image/articles/article3-1.webp';
import image2 from '../image/articles/article3-2.webp';
import image3 from '../image/articles/article3-3.webp';
import image4 from '../image/articles/article3-4.webp';
import image5 from '../image/articles/article3-5.webp';
import image6 from '../image/articles/article3-6.webp';
import image7 from '../image/articles/article3-7.webp';
import image8 from '../image/articles/article3-8.webp';
import article2Thumbnail from '../image/articles/article2_1.webp';
import ProtectedPage from "../components/ProtectedPage";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Divider } from "@mui/material";
import { Wavedivider } from "../components/Wavedivider";
import { QuoteBlock } from "../components/QuoteBlock";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from "../utils/useMetaTags";

function Article3(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
    const hashedPasswords = hashPasswordsFromEnv(
      process.env.REACT_APP_ARTICLE3_PASSWORDS
    );
      const images2 = [image2, image3]; // 2개 이미지
      const images3 = [image4, image5]; // 3개 이미지
      const images4 = [image6, image7]; // 3개 이미지
      const images5 = [image8]; // 3개 이미지
      
      useMetaTags({
        title: '25.09. 회고 - Lynkim',
        description: '영월 / 인트리그미션 게임 / 행복하게 사는 것 / 대도시의 사랑법',
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
          <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
          <div className='fadeIn '>
            <ArticleTitle
              title={'25.09. 회고'}
              titleEn={'25.09. Retrospective'}
              description={'영월 / 인트리그미션 게임 / 행복하게 사는 것 / 대도시의 사랑법'}
              descriptionEn={'Yeongwol trip / The Intrigue Mission game / Living happily / Love in the Big City'}
              category={'essay'}
              date={'2025.10.01.'}
              thumbnail={image1}/>
          </div>
          <Wavedivider/>
          <div className='articleLayout'>
            <ArticleTextSection 
                title = '프롤로그' 
                subTitle = '영월'
                description=
                  {<div> 
                    회사 동료들과 함께 셋이서 영월로 여행을 갔다. 바쁘게 돌아가는 일상에서 벗어나서 자연 안으로 들어가보니, 정신없이 흘러가는 회사의 시간과 다르게, 시간이 하나하나 흘러가는게 피부로 느껴졌다. <br/>
                    돌산을 바라보고 멍하게 앉아있으니까 왠지 너무 작은 세상 안에서 작은 것에 괜히 힘들어하며 또 살아왔구나 하는 생각이 들었다. <br/>
                    <br/>
                    자연을 바라보면서 문득 그런 이야기를 했는데, 불과 5년 전에는 여유도 없고 가진 것이 없어서, 나 하나 먹여주고 입혀주는 것이 사치로 느껴졌었다고. 그래서 남들이 누리는 맛있는 음식, 비싼 음식, 짧은 여행 하나도 내 삶에서는 주어지지 않을 사치같은 것이라고. 근데 지금와서 보니 삶이 버티는 것에서 편안함으로 바뀌어 있었더라.<br/>
                    그말을 듣고 옆에 있던 사람이 5년 전의 나에게 말해줄 수 있다면 뭐라고 말해줄거냐고 물어봤는데, 곰곰히 생각해보면 이렇게 말해줬을 것 같다. <br/>
                    <br/>
                    <b>당장에 나에게는 다른 사람들의 여유같은 것들이 살아생전 주어지지 않을 것 같이 보여도, 지금을 버티고 살아내다 보면 모르는 새 더 나은 삶을 살고 있을거야. 그러니까 조급해하지 말자.</b><br/>
                    <br/>
                    곧 퇴사하는 동료가 나 덕분에 회사 생활이 즐거웠다고 했는데, 왠지 모르게 감동받아서 울컥했다. 그런데 나도 마찬가지로 옆에 있어줘서 얼마나 위로되고 행복했는지 모른다.
                    </div>}
            />
            
            <ArticleImageLayout images={images2} />
            
            <ArticleTextSection 
                marginTop={true}
                subTitle = '인트리그미션 게임'
                description=
                  {<div> 
                    행사나 게임 기획을 너무 좋아해서 회사에서도 서바이벌 게임을 기획한 적이 많았는데, 이번에는 회사사람들과 함께 두뇌 서바이벌게임 [인트리그미션]에 참여해봤다. 기획자가 아닌 게임 플레이어로 참여하는 것은 거의 처음인 것 같다. 총 6시간이나 게임을 했지만 전혀 지루하지 않았고, 시간이 어떻게 흘러간지 모르게 게임을 즐기고 있었다. 다들 몰입해서 열정적으로 참여해서 그런지 훨씬 즐거웠고, 배신도 하고, 연기도 하고, 전략도 짜보고 하는 경험이 너무 재미있었다. <br/>

                    게임에 참여해보니 나는 결과보다는 과정에 초점을 더 두는 편인 것 같다. 승부욕이 꽤나 있는편이라고 생각했는데, 등수보다는 그래도 꽤나 똑똑하게 플레이했는걸? 하는 생각을 더 많이 했던 것 같다. <br/>

                    그런데 확실히 나도 한 게임 좋아한다고 생각했는데, 진짜 좋아하는 사람들에 껴보니까 좋아한다고 하지도 못하겠다. 

                    하지만 역시 참여보다도 게임 기획이 더 재미있는 것 같다. 내내 <b>이런 게임을 만들고 사람들이 내가 만든 게임에 참여하면 얼마나 재미있을까?</b> 하는 생각을 더 많이했다.
                    </div>}
            />   

            <ArticleImageLayout images={images3} />
            <ArticleImageLayout images={images4} />
            
            <ArticleTextSection 
                marginTop={true}
                title = '[삶] 행복하게 사는 것'
                description=
                  {<div>
                    심리학 고양이라는 유튜브 채널을 좋아한다. 재미있게 이야기를 풀어주는데 내용은 삶을 살아가는데 도움이 되는 내용들이 많다. 얼마전에 행복의 정의에 대한 콘텐츠를 봤는데, 이번 달에 본 콘텐츠 중에 가장 인상깊이 남은 내용이었다. <br/>
                    <CalloutLink href="https://www.youtube.com/watch?v=nz8AICRZZ-M">
                      행복의 정의 | 심리학 고양이
                    </CalloutLink>

                    행복의 정의는 여러가지가 있겠지만, 가장 중요하게도 행복은 <b>타인</b>이다. 라는 메세지를 전달하고 있었다. <br/>

                    효과적으로 행복을 높이고 효과적으로 우울과 불안을 낮누는 방법은 타인을 돕는 것이라고 한다.(심리학자 셀리그만이 한 말이다.) <br/>

                    생각해보면, 내가 진심으로 다른 사람을 위한 행동을 했다라는 사실만으로 마음이 왠지 뭉클하고 저려오는 느낌이 드는 적이 많았던 것 같다. 무언가 화가나고, 뜻대로 되지 않아서 우울한 감정이 든다면, 그냥 이유없이 한번 다른 사람을 위한 행동을 하고 다시 행복함을 느껴보자. <br/>
                    <br/>
                    아래는 콘텐츠에서 가장 인상깊은 내용이다.<br/>

                    <QuoteBlock>
                      스티븐 어머니는 기분이 언짢을 때 마다 "골이난 모양이구나 밖에 나가서 다른 사람들을 도와주지 않으련?" 이라고 말했다. <br/>
                      친절한 행위는 행복을 증가시키고, 새벽 4시 고민을 털어 놓을 수 있는 친구가 있으면 더 오래 산다. <br/> 
                      부와 명예가 아닌 사회적 연결이 긴밀할수록 훨씬 더 행복하게 살고 있었다. <br/> 
                      행복은 내가 행복하다는 사실을 매순간 기억하는 것
                    </QuoteBlock>
                    </div>} 
                marginBottom={true}
            />

            <ArticleTextSection 
                marginTop={true}
                title = '[영화] 대도시의 사랑법'
                description=
                  {<div>
                    <CalloutLink href="https://youtu.be/VRfFd7Dl7IE?si=_TAIRBFOOQCpCeq8">
                      대도시의 사랑법
                    </CalloutLink>
                    왠지 외로움을 많이 느끼면, 사람이 그냥 살아가면서 겪는 이야기, 느끼는 감정, 그들의 관계에 초점을 맞춘 스토리에 손이 간다. 이번달 유튜브를 보면 외로움이라는 키워드를 가장 많이 검색했었다. 곰곰히 생각해보면 외로움보다는 상실감이 더 컸던 것 같다. 감정이 크게 요동친 적이 많았고, 그래서 옆에 있는 사람에게 괜한 말로 큰 상처를 줬을지도 모르겠다. <br/>
                    아무튼 그렇게 선택한 영화인데, 정말로 올해 본 영화 중에 가장 인상깊고 재미있게 본 영화가 됐다. 오래토록 기억에 남을 것 같다. <br/>
                    <br/>
                    영화의 두 주인공 중에 여자 재희의 이야기에 깊이 빠져들었고, 여자 주인공의 감정이 그대로 마음에 스며들어서 웃을 때 함께 웃고, 눈물을 흘릴 때 함께 오열했다. <br/>
                    당장 스무살이 되면, 모두가 갑자기 세상에 내던져져서, 아무것도 잘 알지 못한채 서툰 삶을 살아가게 되는 것 같다. 그래서 남을 이유없이 미워도 해보고, 사람들과의 깊은 관계를 만들기 위해 다른 사람의 부끄러움조차 가벼이 이야깃거리로 만들기도 한다. 그래서 여자 주인공을 가십으로 만든 그 주변 사람들을 마냥 욕하기보다 가여운 시선으로 보게 되기도 했다. <br/>
                    <br/>
                    누구나 처음부터 나인게 있는 그대로 아무렇지 않은 사람은 없는 것 같다. 사회에 나와 모르는 사람들 안에 놓여지면서, 남들과 다름을 먼저 보게되고, 남들과 비슷해지기 위해 내가 아닌 모습을 체득하고, 바꾸고, 비슷해지면서 그렇게 살아남아 가는 것 같다. <br/>
                    그게 꼭 나쁜것 만은 아니게, 그러다보면 서로 처음 만난 사이더라도 어색해지지 않게 웃어넘기는 방법을 배워갔고, 나의 모난 모습을 갈아내어 둥글둥글하게 살아가는 방법을 배우게 된다.<br/>
                    그러면서 조금씩 나를 지켜내자 다짐하고, 남들과 다름을 찾아내고, 그 모습을 또 소중히 여기며 조금씩 드러내게 되는 것 같다. 그러니까 살아가면서 남과 다른 내 모습에 실망하거나 꼭 맞춰가려고 하지 말고, 내가 좋아하는 것, 잘하는 것에 더 집중해서 가꿔나가면 좋겠다. <br/>
                    <br/>
                    영화를 볼 때 가장 인상깊은 구절이다. <br/>
                    <QuoteBlock>집착이 사랑이 아니라면 난 단 한번도 사랑해본 적이 없다. </QuoteBlock>
                    꼭 사람에게 집착이 아니더라도 사랑하는 모든 것에 이상할 정도로 집착하고, 예민해지는 게 이상하지 않고 당연했던게 아닐까.<br/>
                    정말 너무 사랑한다면, 살아가면서 잃어버리고, 놓쳐버린 관계, 꿈이였더라도, 다시 돌아온 순간에는 놓치지 않기 위해 온 힘을 다해 집착해보면 어떨까.
                    
                    </div>} 
                marginBottom={true}
            />
            <ArticleImageLayout images={images5} />
          </div>    
          
          <NextItem to='/Article2' thumbnail={article2Thumbnail} nextProjectTitle='25.08. 회고'/>

          <BackButton/>
          </ProtectedPage>
        </>
      )
  }
  
  export default Article3;
